<ion-header>
  <ion-toolbar class="header-color">
      <ion-buttons slot="start">
          <ion-back-button defaultHref="search/promotions"></ion-back-button>
        </ion-buttons>
    <ion-title>Booking Confirmed</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <div class="center m-auto mt4" *ngIf="studio">
          <ion-icon name="checkmark-circle" class="checkMark"></ion-icon>
          <h3 class="title">{{ plan.name | titlecase }} at {{ studio.name | titlecase }}</h3>
          <p class="confirmation">Pass Confirmed!</p>
          <p class="confirmMail" *ngIf="emailId">A confirmation email has been sent to {{emailId}}.</p>
          <p class="notes">Contact the studio for reservation.
            <svg (click)="openTooltip($event)"
              xmlns="http://www.w3.org/2000/svg" class="session-venue-svg h-5 w-5" viewBox="0 0 20 20"
              fill="currentColor">
             <path fill-rule="evenodd"
                   d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                   clip-rule="evenodd"/>
         </svg>
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
